import { Button } from '@racefront/shadcn-ui'
import { Trophy, Users } from 'lucide-react'
import { FormattedMessage } from 'react-intl'
import { useSearchParams } from 'react-router-dom'

type UserRole = 'organizer' | 'profile_user'

type RoleSelectionProps = {
  onRoleSelect: (role: UserRole) => void
}

export function RoleSelection({ onRoleSelect }: RoleSelectionProps) {
  const [, setSearchParams] = useSearchParams()

  const handleRoleSelect = (role: UserRole) => {
    setSearchParams({ role })
    onRoleSelect(role)
  }

  return (
    <div className="flex min-h-[500px] flex-col items-center justify-center">
      <div className="w-full max-w-md space-y-8 px-4">
        <div className="text-center">
          <h3 className="text-3xl font-bold">
            <FormattedMessage id="signup.role_selection.title" defaultMessage="What are you after?" />
          </h3>
          <p className="text-muted-foreground mt-3 text-lg">
            <FormattedMessage
              id="signup.role_selection.subtitle"
              defaultMessage="Choose how you want to use the platform"
            />
          </p>
        </div>

        <div className="flex flex-col gap-4">
          <Button
            variant="outline"
            className="hover:border-primary hover:bg-primary/5 group h-auto flex-col gap-4 p-8 transition-all"
            onClick={() => handleRoleSelect('organizer')}
          >
            <div className="bg-primary/10 group-hover:bg-primary/20 rounded-full p-4 transition-colors">
              <Trophy className="text-primary h-8 w-8" />
            </div>
            <div className="space-y-2 text-center">
              <h4 className="text-xl font-semibold">
                <FormattedMessage
                  id="signup.role_selection.organizer_title"
                  defaultMessage="I want to organize races"
                />
              </h4>
              <p className="text-muted-foreground text-sm">
                <FormattedMessage
                  id="signup.role_selection.organizer_description"
                  defaultMessage="Create and manage racing events"
                />
              </p>
            </div>
          </Button>

          <Button
            variant="outline"
            className="hover:border-primary hover:bg-primary/5 group h-auto flex-col gap-4 p-8 transition-all"
            onClick={() => handleRoleSelect('profile_user')}
          >
            <div className="bg-primary/10 group-hover:bg-primary/20 rounded-full p-4 transition-colors">
              <Users className="text-primary h-8 w-8" />
            </div>
            <div className="space-y-2 text-center">
              <h4 className="text-xl font-semibold">
                <FormattedMessage
                  id="signup.role_selection.racer_title"
                  defaultMessage="I want to participate in races"
                />
              </h4>
              <p className="text-muted-foreground text-sm">
                <FormattedMessage
                  id="signup.role_selection.racer_description"
                  defaultMessage="Join races and compete"
                />
              </p>
            </div>
          </Button>
        </div>
      </div>
    </div>
  )
}
